// Views
import Home from '@/views/Home.vue'
import About from '@/views/About.vue'
import EmailConfirm from '@/views/EmailConfirm'
import PlayGame from '@/views/Play'
import Contact from '@/views/Contact'
import Ranking from '@/views/Ranking'
import News from '@/views/News.vue'
import Policy from '@/views/Policy'
import Commands from '@/views/Commands'

var d = new Date

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
          title: 'Juega MUCRISIS ༒ El mejor servidor clásico 97d de MuOnline '+d.getFullYear(),
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: '⭐️ MuCrisis es un servidor privado de Mu Online versión clásica 97d. No es como cualquier otro servidor, a pesar de ser viejo, es un juego lleno de retos y diversión para disfrutar con tus amigos.'
            },
            {
              property: 'og:description',
              content: '⭐️ MuCrisis es un servidor privado de Mu Online versión clásica 97d. No es como cualquier otro servidor, a pesar de ser viejo, es un juego lleno de retos y diversión para disfrutar con tus amigos.'
            }
          ]
        }
      },
      {
        path: '/informacion',
        name: 'about',
        component: About,
        meta: {
          title: 'Acerca de MUCRISIS ༒ información detallada',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: 'Todo lo referente al juego y sus caracteristicas ⭐️ MuCrisis es un servidor privado de MuOnline versión clásica 97d+99i.'
            },
            {
              property: 'og:description',
              content: 'Todo lo referente al juego y sus caracteristicas ⭐️ MuCrisis es un servidor privado de MuOnline versión clásica 97d+99i.'
            }
          ]
        }
      },
      {
        path: '/confirmar-correo/:key',
        name: 'email_confirm',
        component: EmailConfirm
      },
      {
        path:'/jugar',
        name: 'play_game',
        component:PlayGame,
        meta: {
          title: 'Jugar MUCRISIS gratis ༒ Descargar cliente',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: '⭐️ Descarga y juega MUCRISIS completamente gratis! pasa horas de entretenimiento con este servidor clásico de MuOnline.'
            },
            {
              property: 'og:description',
              content: '⭐️ Descarga y juega MUCRISIS completamente gratis! pasa horas de entretenimiento con este servidor clásico de MuOnline.'
            }
          ]
        }
      },
      {
        path:'/contacto',
        name: 'contact',
        component:Contact,
        meta: {
          title: 'Contacto MUCRISIS ༒ Ayuda/Sugerencias',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: '⭐️ Contáctanos si necesitas ayuda o si deseas ofrecer tu sugerencias, el equipo de MUCRISIS estará encantado de ayudarte.'
            },
            {
              property: 'og:description',
              content: '⭐️ Contáctanos si necesitas ayuda o si deseas ofrecer tu sugerencias, el equipo de MUCRISIS estará encantado de ayudarte.'
            }
          ]
        }
      },
      {
        path: '/novedades',
        name: 'news',
        component: News,
        meta: {
          title: 'Todo lo nuevo de MUCRISIS',
          layout: 'default'
        }
      },
      {
        path:'/ranking',
        name: 'score',
        component:Ranking,
        meta: {
          title: 'Ranking MUCRISIS ༒ Los mejores jugadores y Gremios',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: '⭐️ Solo lo mejor de lo mejor, los jugadores y gremios del servidor MUCRISIS se encuentran aquí, juega y sube en la clasificación para lograr ser el mejor.'
            },
            {
              property: 'og:description',
              content: '⭐️ Solo lo mejor de lo mejor, los jugadores y gremios del servidor MUCRISIS se encuentran aquí, juega y sube en la clasificación para lograr ser el mejor.'
            }
          ]
        }
      },
      {
        path:'/ranking/:id',
        name: 'score_by_kind',
        component:Ranking,
        meta: {
          title: route => {
              var kind = route.params.id
              switch (kind) {
                case 'jugadores':
                  return 'Ranking de jugadores MUCRISIS ༒ Los mejor de lo mejor'
                case 'gremios':
                  return 'Ranking de gremios MUCRISIS ༒ Los mejores de todo el servidor'
                case 'asesinos':
                  return 'Ranking de asesinos MUCRISIS ༒ Los más buscados'
              }
            },
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: route => {
                var kind = route.params.id
                switch (kind) {
                  case 'jugadores':
                    return 'Lo mejor de lo mejor, en esta sección estan los jugadores más destacados de todo el servidor de MUCRISIS, esfuerzate para ser uno de ellos.'
                  case 'gremios':
                    return 'Los gremios más poderosos de todo el servidor de MUCRISIS se encuentran aquí, compite con tus amigos contra otros para escalar y ser el gremio mas fuerte.'
                  case 'asesinos':
                    return 'Los mas buscados de todo el servidor de MUCRISIS, malevolos jugadores sin piedad hacia otros, sí! Tambien tienen un ranking.'
                }
              }
            }
          ]
        }
      },
      {
        path:'/comandos',
        name: 'commands',
        component:Commands,
        meta: {
          title: 'Comandos MUCRISIS ༒ mejora tu calidad de juego',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: 'Todos los comandos utilizables dentro del juego, facilita tu jugabilidad con diferentes trucos que puedes aplicar en el transcurso de tu aventura.'
            },
            {
              property: 'og:description',
              content: 'Todos los comandos utilizables dentro del juego, facilita tu jugabilidad con diferentes trucos que puedes aplicar en el transcurso de tu aventura.'
            }
          ]
        }
      },
      {
        path:'/politica-de-privacidad',
        name: 'privacypolicy',
        component:Policy,
        meta: {
          title: 'MUCRISIS ༒ Política de privacidad',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: 'Política de privacidad de MUCRISIS.'
            },
            {
              property: 'og:description',
              content: 'Política de privacidad de MUCRISIS.'
            }
          ]
        }
      }
]

export default routes